/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-09T15:06:38.924
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveFinancePaymentItem,
	getFinancePaymentItemCreateInit,
	getFinancePaymentItemEditInit,
	getFinancePaymentItemView,
	deleteFinancePaymentItem
} from '@api/storagemanage/FinancePaymentItem';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getFinancePaymentItemCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getFinancePaymentItemCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancePaymentItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancePaymentItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveFinancePaymentItem({}, FinancePaymentItem) {
			return new Promise((resolve, reject) => {
				saveFinancePaymentItem(FinancePaymentItem)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancePaymentItemView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancePaymentItemView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancePaymentItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancePaymentItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
